<template>
    <div class="slm-event-list__filters-selected">
        <div class="slm-event-list__filters-selected--filters">
            <button class="slm-event-list__filters-selected--remove" :class="filter.type" v-for="filter in selectedFilters" :key="filter.value" @click="removeFilter(filter)">
                <span class="show-for-sr">Ta bort filter:</span>
                {{filter.title}}
            </button>
            <button v-if="selectedFilters.length" class="slm-event-list__filters-selected--remove-all" @click="resetFilter()">
                Rensa filter
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'selected-filters-component',
    props: ['id'],
    computed: {
        selectedFilters() {
            let filters = this.$store.state[this.id].filters;
            const selected = filters.options.filter(f => f.selected)
            return selected;
        },
    },
    methods: {
        removeFilter(filter) {
            this.$store.commit('removeFilter', filter);
            this.$store.commit('setPage', {
                id: this.id,
                page: 1
            });
            this.$store.dispatch('setUrl');
            this.$store.dispatch('newSearch', this.id);
        },
        resetFilter() {
            this.$store.commit('resetAllFilters', this.id);
            this.$store.commit('setPage', {
                id: this.id,
                page: 1
            });
            this.$store.dispatch('setUrl');
            this.$store.dispatch('newSearch', this.id);
        }
    }
}
</script>